<template>
  <!-- Can't use hero class because there are some overlap issues with the   -->
  <!-- navigation bar. A patch has been merged in dev that I believe fixes   -->
  <!-- this problem. Awaiting for merge in master and npm package update.    -->
  <!-- See: https://github.com/buefy/buefy/pull/2105                         -->
  <section class="section">
    <div class="container">
      <b-steps
        v-model="activeStep"
        :size="stepsProperties.size"
        :has-navigation="stepsProperties.hasNavigation"
      >
        <b-step-item
          :label="$t('views.sign.authentication.label')"
          :clickable="false"
          icon="account-key"
        >
          <h2 class="subtitle has-text-centered">
            {{ $t('views.sign.authentication.subtitle') }}
          </h2>

          <Authentication
            v-if="activeStep == 0"
          />
        </b-step-item>

        <b-step-item
          :label="$t('views.sign.signatureProviderSelection.label')"
          icon="draw"
        >
          <h2 class="subtitle has-text-centered">
            {{ $t('views.sign.signatureProviderSelection.subtitle') }}
          </h2>

          <SignatureProviderSelection
            v-if="activeStep == 1"
            @signatureProviderSelected="activeStep = 2"
          />
        </b-step-item>

        <b-step-item
          :label="$t('views.sign.documentUpload.label')"
          icon="upload"
        >
          <h2 class="subtitle has-text-centered">
            {{ $t('views.sign.documentUpload.subtitle') }}
          </h2>

          <DocumentUpload
            v-if="activeStep == 2"
            @documentUploaded="activeStep = 3"
          />
        </b-step-item>

        <b-step-item
          :label="$t('views.sign.documentSigning.label')"
          icon="upload"
        >
          <h2 class="subtitle has-text-centered" v-show="this.getSelectedSignatureProvider().id != 5">
            {{ $t('views.sign.documentSigning.subtitle') }}
          </h2>

          <DocumentSigning
            v-if="activeStep == 3"
            @documentDownloaded="activeStep = 4"
          />

          <SignaturePreview
            v-if="this.$store.getters.getshowPdfPrv && activeStep == 3"
          />
        </b-step-item>

        <b-step-item
          :label="$t('views.sign.endingStep.label')"
          icon="download"
        >
          <h2 class="subtitle has-text-centered">
            {{ $t('views.sign.endingStep.subtitle') }}
          </h2>

          <EndingStep
            v-if="activeStep == 4"
            @newDocumentSigning="activeStep = 1"
          />
        </b-step-item>
      </b-steps>

    </div>
    <div class="disclaimer">
      {{ $t('common.appDisclaimer') }}
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import Authentication from '@/components/stepper/Authentication.vue'
import DocumentSigning from '@/components/stepper/DocumentSigning.vue'
import DocumentUpload from '@/components/stepper/DocumentUpload.vue'
import EndingStep from '@/components/stepper/EndingStep.vue'
import SignaturePreview from '@/components/stepper/SignaturePreview.vue'
import SignatureProviderSelection from '@/components/stepper/SignatureProviderSelection.vue'

import KeycloakInstance from '@/plugins/KeycloakInstance.js'

export default {
  name: 'Sign',
  components: {
    Authentication,
    DocumentSigning,
    DocumentUpload,
    EndingStep,
    SignaturePreview,
    SignatureProviderSelection
  },
  data () {
    return {
      activeStep: 0,
      showPdfPreview: false,
      stepsProperties: {
        size: 'is-medium',
        hasNavigation: false
      }
    }
  },
  methods: {
    ...mapGetters([
      'getSelectedSignatureProvider'
    ]),
    togglePdfPreview (event) {
      if ((event.key === ']') && event.ctrlKey) {
        this.showPdfPreview = !this.showPdfPreview
      }
    },
    preventUnload (e) {
      // Cancel the event
      e.preventDefault() // If you prevent default behavior in Mozilla Firefox prompt will always be shown
      // Chrome requires returnValue to be set
      e.returnValue = ''
    }
  },
  created () {
    window.addEventListener('keyup', this.togglePdfPreview)
  },
  destroyed () {
    window.removeEventListener('keyup', this.togglePdfPreview)
    window.removeEventListener('beforeunload', this.preventUnload)
  },
  mounted () {
    this.activeStep = KeycloakInstance.isAuth() ? 1 : 0
    // console.log(this.$store.getters.getshowPdfPrv)
  },
  updated () {
    if (!KeycloakInstance.isAuth()) {
      this.activeStep = 0
    } else {
      window.addEventListener('beforeunload', this.preventUnload)
    }
  }
}
</script>
